export var ConnectionEvents;
(function (ConnectionEvents) {
    ConnectionEvents["ConnectionAvailable"] = "ConnectionAvailable";
    ConnectionEvents["ConnectionBusy"] = "ConnectionBusy";
    ConnectionEvents["ConnectionProgress"] = "ConnectionProgress";
})(ConnectionEvents || (ConnectionEvents = {}));
export var UploaderStatus;
(function (UploaderStatus) {
    UploaderStatus["Pending"] = "Pending";
    UploaderStatus["Starting"] = "Starting";
    UploaderStatus["Started"] = "Started";
    UploaderStatus["Queued"] = "Queued";
    UploaderStatus["Paused"] = "Paused";
    UploaderStatus["Resumable"] = "Resumable";
    UploaderStatus["Finishing"] = "Finishing";
    UploaderStatus["Finished"] = "Finished";
    UploaderStatus["Canceling"] = "Canceling";
    UploaderStatus["Canceled"] = "Canceled";
    UploaderStatus["Error"] = "Error";
})(UploaderStatus || (UploaderStatus = {}));
export var UploaderEvents;
(function (UploaderEvents) {
    UploaderEvents["Changes"] = "changes";
    UploaderEvents["Pending"] = "pending";
    UploaderEvents["Starting"] = "starting";
    UploaderEvents["Started"] = "started";
    UploaderEvents["Progress"] = "progress";
    UploaderEvents["Queued"] = "queued";
    UploaderEvents["QueueFinished"] = "queueFinished";
    UploaderEvents["QueueDeleted"] = "queueDeleted";
    UploaderEvents["Paused"] = "paused";
    UploaderEvents["Resumable"] = "resumable";
    UploaderEvents["Finishing"] = "finishing";
    UploaderEvents["Finished"] = "finished";
    UploaderEvents["Canceling"] = "canceling";
    UploaderEvents["Canceled"] = "canceled";
    UploaderEvents["Error"] = "error";
})(UploaderEvents || (UploaderEvents = {}));
export const MAX_EXECUTION_NUMBER = 10;
